import Config from '../../config';
import Module from '../../core/module';
import Preview from '../../view/module/schedule/preview';
import Schedule from '../../model/schedule';
import ScheduleTemplatesModule from './templates.list';

import { hashify } from '../../utils/arrays';
import { fmt, nextYear, prevYear, datify, beginMonth } from '../../utils/date';
import { error } from '../../ui/messages'
import { handle } from '../../service/messages';  
import { ask } from '../../utils/popups';
import { beginLock, endLock } from '../../loader';
import { roleAICK } from '../../roles';





const 
    POPUP_NEW = 'schedule-form--popup-new',
    POPUP_EDIT = 'schedule-form--popup-edit';





export default Module.extend( {

    template: 'jst/module.schedule.form',

    url() {
        const { schedule, groupType } = this.options;
        const openedTab = this.state()[`${groupType}-opened-tab`];
        const urlTemplate = schedule.id
            ? `schedule/${schedule.id}/edit/${groupType}/${openedTab}`
            : `schedule/new/${groupType}/${openedTab}`;

        const yyyy = this.state()[`${groupType}-year`];
        return openedTab == 'random'
            ? urlTemplate + `/${yyyy}`
            : urlTemplate;
    },

    open({ id, schedule, ...otherArgs }) {
        if (!Config.privileges().includes( 'access_schedule' ))
            return Promise.reject( '403 Forbidden' );

        return schedule
            ? this.openSchedule( { schedule, ...otherArgs } )
            : Schedule.byId( id )
                .then( schedule => this.openSchedule( { schedule, ...otherArgs } ) );
    },

    openSchedule({ schedule, groupType = 'weekdays', openedTab, yyyy }) {
        this.options.groupType = groupType;

        const defaultYear = fmt( new Date(), 'YYYY' );
        this.setState( {
            'weekdays-opened-tab': 'times',
            'holidays-opened-tab': 'weekly',
            'weekdays-year': defaultYear,
            'holidays-year': defaultYear,
            [`${groupType}-year`]: yyyy || defaultYear
        } );

        if (openedTab)
            this.setState( {
                [`${groupType}-opened-tab`]: openedTab,
            } );

        const extendPattern = pattern => { 
            pattern.v = hashify( pattern.value );
            pattern.add = {}; 
            pattern.remove = {}; 
        };

        const extendGroup = group => {
            group.random_patterns.forEach( extendPattern );
            group.yearly_patterns.forEach( extendPattern );
            group.monthly_patterns.forEach( extendPattern );
        };

        schedule.get( 'weekdays' ).forEach( extendGroup );
        schedule.get( 'holidays' ).forEach( extendGroup );
        
        return this.options.schedule = schedule,
            this.bind( schedule );
    },

    start() {
        this.listenTo( this.model, 'change:contract', 
            () => {
                if (this.model.get( 'contract' )) {
                    const contract = this.options.contracts.find( contract => 
                        contract.id == this.model.get( 'contract' ).id );
                    if (contract)
                        this.model.set( 'contract', contract.toJSON(),
                            { silent: true } );
                }

                Object.keys( this )
                    .filter( key => key.startsWith( 'Random' ) )
                    .map( key => this[key] )
                    .forEach( randomPatternView => randomPatternView.render() );
            } );

        this.listenTo( this.model, 'change:start_date_time change:finish_date_time', 
            () => {
                Object.keys( this )
                    .filter( key => key.startsWith( 'Random' ) )
                    .map( key => this[key] )
                    .forEach( randomPatternView => randomPatternView.render() );
            } );

        this.listenTo( this.model, 'change',
            () => this.Buttons.render() );

        return this;
    },

    stop() {
        return this.stopListening( this.model, 'change:contract' ),
            this;
    },

    hasDiff(/*options = {}*/) {
        if (!this.Fields || !this.model || !this.Fields.originalModel)
            return false;

        return JSON.stringify( this.model.toJSON() )
            != JSON.stringify( this.Fields.originalModel.toJSON() );
    },

    serialize() {
        const weekdays = this.model.get( 'weekdays' );
        const holidays = this.model.get( 'holidays' );
        const yyyy = this.state()[`${this.options.groupType}-year`];
        const year = datify( `${yyyy}-01-01` );

        const orgsHash = hashify( Config.orgs() );

        return {
            openedTab: this.state()[`${this.options.groupType}-opened-tab`],
            weekdays, holidays,
            prevYear: prevYear( year ),
            nextYear: nextYear( year ),
            year,
            hasDiff: () => this.hasDiff(),
            organizations: roleAICK.includes( Config.role() )
                ? this.options.organizations
                : this.options.organizations.toJSON()
                    .filter( org => orgsHash[org.id] )
        };
    },

    afterRender() {
        const [emptyIndex, duplicateIndexes] = findInvalidInputs.call( this );
        const errFn = errIndex => 
            this.$( '.schedule--time-list [type=time]' ).eq( errIndex )
                .closest( '.form-group' )
                .addClass( 'has-error' )

        if (emptyIndex !== undefined)
            return errFn( emptyIndex );

        if (duplicateIndexes)
            return duplicateIndexes.forEach( errFn );
    },

    events: {

        'click .-group-tab-switch'({ originalEvent: { target } }) {
            const { tabName } = target.dataset;

            // to ignore clicking on inner checkbox
            if (this.$( target ).is( '.-group-tab-switch' ))
                return this.setState( { [`${this.options.groupType}-opened-tab`]: tabName } ), 
                    this.render().then( () => this.navigated() );
        },

        'change [type="time"]'(e) {
            const { weekdaysIndex, timeIndex } = e.target.dataset;
            const enteredTime = this.$( e.target ).val();

            changeTimes.call( this, +weekdaysIndex,
                times => times.map( (tm, index) => index == timeIndex
                    ? { ...tm, time: enteredTime || tm.time }
                    : tm ) );

            if (enteredTime)
                this.$( e.target ).closest( '.form-group' )
                    .removeClass( 'has-error' );
        },

        'change .schedule--time-list [type="checkbox"]'(e) {
            const { weekdaysIndex, timeIndex } = e.target.dataset;
            changeTimes.call( this, +weekdaysIndex,
                times => times.map( (tm, index) => index == timeIndex
                    ? { ...tm, on: e.target.checked }
                    : tm ) )

            this.$( e.target )
                .closest( '.row-by-3' ).find( '[type=time]' )
                .prop( 'readonly', !e.target.checked );
        },

        'click .schedule--time-list-input .input-group-addon'(e) {
            const { weekdaysIndex, timeIndex } = this.$( e.target )
                .closest( '.input-group' ).find( '[type="time"]' )
                [0]
                .dataset;

            changeTimes.call( this, +weekdaysIndex,
                times => times.filter( (_, index) => index != timeIndex ) );

            return this.render();
        }

    },

    [Module.event( 'Buttons:form:save' )]() {
        const [emptyIndex, duplicateIndexes] = findInvalidInputs.call( this );
        if (emptyIndex !== undefined || duplicateIndexes )
            return this.options.groupType = 'weekdays',
                this.setState( { 'weekdays-opened-tab': 'times' } ),
                this.render().then( () => this.navigated() );

        beginLock( this );
        
        return save.call( this ).then( 

            schedule => this.model.id
                ? this.trigger( Module.BACK )
                : this.trigger( ScheduleTemplatesModule.REPLACE,
                        schedule ), 

            message => {
                endLock( this );
                handle( this.Fields, error( message ) );
            } );
    },

    [Module.event( 'Buttons:form:preview' )]() {
        const view = new Preview( {
            month: beginMonth( new Date() ),
            attrs: json.call( this )
        } );

        return ask( view.render(), 'actions::preview', 'actions::close',
            undefined,
            { large: true } );
    },

    [Module.event( 'Buttons:form:close' )]() {
        this.trigger( Module.BACK );
    },

    [Module.event( 'group:switch' )](groupType) {
        return this.options.groupType = groupType,
            this.render().then( () => this.navigated() );
    },

    [Module.event( 'dayOfWeek:toggle' )](dayOfWeek, originalPattern) {
        const { pattern, ...props } = this.model.clonePattern( originalPattern );

        if (pattern.value.includes( dayOfWeek ))
            pattern.value = pattern.value.filter( d => d !== dayOfWeek );
        else
            pattern.value = [...pattern.value, dayOfWeek];

        return this.model.set( props ), this.render();
    },

    [Module.event( 'pattern:toggle' )](originalPattern) {
        const { pattern, ...props } = this.model.clonePattern( originalPattern );
        return pattern.on = !pattern.on,
            this.model.set( props ),
            this.render();
    },

    [Module.event( 'time:add' )](weekdaysIndex) {
        changeTimes.call( this, +weekdaysIndex,
            times => [...times, { time: undefined, on: true }] );

        return this.render().then(
            () => this.$el.find( '.schedule--time-list [type=time]' )
                .last()
                .focus()
                .closest( '.form-group' )
                .removeClass( 'has-error' ) );
    },

    [Module.event( 'year:set' )](year) {
        return this.setState( { [`${this.options.groupType}-year`]: fmt( year, 'YYYY' ) } ),
            this.render().then( () => this.navigated() );
    },

}, {

    POPUP_NEW,

    POPUP_EDIT,

} );





function json() {
    const { 
        templates, 
        weekdays, holidays,
        ...otherAttrs } = this.model.toJSON();

    const mapPatternFn = ({ value, v, add, remove, ...attrs }) => ({
        ...attrs,
        value: [
            ...Object.keys( add ),
            ...Object.keys( v ).filter( val => !remove[val] )
        ]
    });

    const mapGroupFn = group => {
        const {
            random_patterns, yearly_patterns,
            monthly_patterns,
            // weekly_patterns is just array of values
            ...otherAttrs } = group;

        return {
            ...otherAttrs,
            random_patterns: random_patterns.map( mapPatternFn ),
            yearly_patterns: yearly_patterns.map( mapPatternFn ),
            monthly_patterns: monthly_patterns.map( mapPatternFn ),
        }
    };

    const attrs = { ...otherAttrs, }

    if (this.Fields.originalModel) {
        const originalWeekdays = this.Fields.originalModel.get( 'weekdays' );
        if (JSON.stringify( weekdays ) !== JSON.stringify( originalWeekdays ))
            attrs.weekdays = weekdays.map( mapGroupFn );

        const originalHolidays = this.Fields.originalModel.get( 'holidays' );
        if (JSON.stringify( holidays ) !== JSON.stringify( originalHolidays ))
            attrs.holidays = holidays.map( mapGroupFn );
    }

    return attrs;
}

function save() {
    if (this.model.id)
        // todo pattern.v, add, remove
        return this.model.patch( json.call( this ) );
    
    return new Schedule( json.call( this ) )
        .save()
        // todo pattern.v, add, remove
        .then( attrs => new Schedule( attrs ) );
}

function findInvalidInputs() {
    const weekdays = this.model.get( 'weekdays' );
    const times = (weekdays[0] || [])
        .times
        .map( (time, index) => [time, index] );
    const emptyTimes = times
        .filter( ([time]) => !time.time );
    const nonEmptyTimes = times
        .filter( ([time]) => !!time.time );

    const [[_, emptyIndex]] = emptyTimes.length ? emptyTimes : [[]];

    const hash = hashify( nonEmptyTimes, ([time, index], hash) => {
        const indexes = hash[time.time] || [];
        return [time.time, [...indexes, index]];
    } );

    const [duplicateIndexes] = Object.values( hash )
        .filter( indexArray => indexArray.length > 1 );

    return [emptyIndex, duplicateIndexes];
}

function changeTimes(weekdaysIndex, timesFn) {
    const weekdays = [...this.model.get( 'weekdays' )];

    weekdays[weekdaysIndex] = { 
        ...weekdays[weekdaysIndex],
        times: timesFn( weekdays[weekdaysIndex].times )
    };

    return this.model.set( 'weekdays', weekdays );
}


// WEBPACK FOOTER //
// ./src/js/module/schedule/form.js